import UserPageShell from "@/components/layout/UserPageShell";

export default function AuthPageSuspenseFallback() {
  return (
    <UserPageShell
      width="full"
      showGlow={false}
      mainClassName="flex min-h-dvh items-center justify-center px-4 py-[calc(var(--page-pad-top)+env(safe-area-inset-top))] text-[color:var(--color-muted-foreground)]"
    >
      <p className="text-base font-medium">Loading sign-in…</p>
    </UserPageShell>
  );
}
